// Removed react-native dependencies and replaced them with standard web APIs for responsive font calculations.
export class Utils {
  static RFValue(fontSize: number, standardScreenHeight: number = 926): number {
    const {
      innerHeight: height,
      innerWidth: width,
    }: { innerHeight: number; innerWidth: number } = window;
    const standardLength: number = width > height ? width : height;

    const deviceHeight: number = standardLength;

    if (deviceHeight > standardScreenHeight) {
      return fontSize;
    } else {
      const heightPercent: number =
        (fontSize * deviceHeight) / standardScreenHeight;
      return Math.round(heightPercent > 100 ? 100 : heightPercent);
    }
  }
}

export const RFValue = Utils.RFValue;
